import auth from "../middleware/auth";

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Início", link: "/" }
];

const LoginRematricula = () =>
  import("../components/Views/Rematricula/Login.vue");
const Inicio = () => import("../components/Views/Inicio.vue");

const responsavel = [
  {
    path: "/responsavel",
    component: Inicio,
    meta: {
      middleware: auth,
      breadcrumb
    }
  },
  {
    path: "/responsavel/login",
    component: LoginRematricula
  },
  {
    path: "/responsavel/login/:cpf/:nascimento",
    component: LoginRematricula
  },
  {
    path: "/responsavel/login/:cpf/:nascimento/:codigoAcesso",
    component: LoginRematricula
  },
  {
    path: "/responsavel/login/:cpf/:nascimento/:codigoAcesso/:responsavel",
    component: LoginRematricula
  },
];

export default responsavel;



// WEBPACK FOOTER //
// ./src/routes/responsavel.js